import { Flex, Modal, Progress } from "antd";
import React, { useEffect, useState } from "react";
import CustomTypography from "../common/CustomTypography";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../common/CustomButton";
import { useNavigate } from "react-router-dom";
import { setExtractedData } from "../../store/reducers/slices/extractedData.slice";
import { setHomeDetails } from "../../store/reducers/slices/home.slice";


///
// backgroundColor:
//                           allStatus.statusInfoAccountAnalysis[index] ===
//                             'INITIALISING' ||
//                           allStatus.statusInfoAccountAnalysis[index] ===
//                             'IN PROGRESS'
//                             ? '#00000014'
//                             : allStatus.statusInfoAccountAnalysis[index] ===
//                                 'ANALYSED' ||
//                               allStatus.statusInfoAccountAnalysis[index] ===
//                                 'Data is ready' ||
//                               allStatus.statusInfoAccountAnalysis[index] ===
//                                 'ACTIVE' ||
//                               allStatus.statusInfoAccountAnalysis[index] ===
//                                 'User consent received' ||
//                               allStatus.statusInfoAccountAnalysis[index] ===
//                                 'Completed'
//                             ? '#2E7D32'
//                             : allStatus.statusInfoAccountAnalysis[index] ===
//                                 'ANALYSIS ON HOLD' ||
//                               allStatus.statusInfoAccountAnalysis[index] ===
//                                 'PRE-ANALYSIS CHECK FAILED' ||
//                               allStatus.statusInfoAccountAnalysis[index] ===
//                                 'Account not found' ||
//                               allStatus.statusInfoAccountAnalysis[index] ===
//                                 'Data not found' ||
//                               allStatus.statusInfoAccountAnalysis[index] ===
//                                 'No user consent' ||
//                               allStatus.statusInfoAccountAnalysis[index] ===
//                                 'User consent declined' ||
//                               allStatus.statusInfoAccountAnalysis[index] ===
//                                 'Data fetch failed'
//                             ? '#D32F2F'
//                             : '#5850EC'

// color:
//                           allStatus.statusInfoAccountAnalysis[index] ===
//                             'INITIALISING' ||
//                           allStatus.statusInfoAccountAnalysis[index] ===
//                             'IN PROGRESS'
//                             ? '#000000DE'
//                             : '#FFFFFF',


///
const ReportStatusModal = ({ open, handleOk, handleCancel, data }) => {
    const { reportAnalysisProgress: reportStatus } = useSelector(({ createReport }) => createReport);
    console.log("reportStatus", reportStatus);
    const [progress, setProgress] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const getBackground = (status) => {
        console.log("Background Status:", status);


        if (status === 'INITIALISING' || status === 'IN PROGRESS') {

            return '#00000014'
        } else if (status === 'ANALYSED' || status === 'Data is ready' || status === 'ACTIVE' || status === 'User consent received' || status === 'Completed') {
            return '#2E7D32'
        } else if (status === 'ANALYSIS ON HOLD' || status === 'PRE-ANALYSIS CHECK FAILED' || status === 'Account not found' || status === 'Data not found' || status === 'No user consent' || status === 'User consent declined' || status === 'Data fetch failed') {
            return '#D32F2F'
        } else {
            return '#5850EC'
        }
    }

    const getColor = (status) => {
        console.log("Colour Status:", status);
        if (status === 'INITIALISING' || status === 'IN PROGRESS') {
            return '#000000DE'
        } else {
            return '#FFFFFF'
        }
    }

    const handleViewAnalysis = () => {
        dispatch(setExtractedData(null))
        dispatch(setHomeDetails(null));
        navigate(`/reports/${reportStatus?.report?.reportId}`)
    }


    // const getProgress = () => {
    //     let totalAccounts = reportStatus?.reportAccounts?.length;
    //     let analysedAccounts = reportStatus?.reportAccounts?.filter(item => item.account.statusDescription === "ANALYSED").length;
    //     let progress = (analysedAccounts / totalAccounts) * 100;
    //     return progress;
    // }

    useEffect(() => {
        let totalAccounts = reportStatus?.reportAccounts?.length;
        console.log("totalAccounts", totalAccounts);

        let analysedAccounts = reportStatus?.reportAccounts?.filter(item => item.account.status === "ANALYSED").length;
        console.log("analysedAccounts", analysedAccounts);

        let progress_var = (analysedAccounts / totalAccounts) * 100;
        // let progress_var = 100;
        console.log("progress_var", progress_var);

        setProgress(progress_var)
    }, [reportStatus])

    console.log("PROGRESS", progress);


    return (
        <Modal
            title={<CustomTypography style={{ fontWeight: 700, fontSize: "16px", lineHeight: "24px", color: `#000000E0` }}>{reportStatus?.report?.reportStatus}</CustomTypography>}
            open={open}
            // onOk={handleOk}
            // confirmLoading={confirmLoading}
            closable={false}
            // onCancel={handleOk}
            footer={[
                <CustomButton key="close" onClick={handleOk}>
                    Close
                </CustomButton>,
                progress === 100 && (
                    <CustomButton type={"primary"} onClick={handleViewAnalysis}>View Analysis</CustomButton>
                ),
            ]}
            styles={{
                header: {
                    paddingInline: "16px"
                },
                footer: {
                    paddingInline: "16px "
                }
            }}
        >
            <div style={{ padding: "16px" }}>
                <Flex vertical gap={"small"}>
                    <CustomTypography style={{ fontWeight: 500, fontSize: "14px", lineHeight: "16.0px", color: '#000000E0' }}>{`Analysis may take up to 5 minutes, depending on the reportStatus size.`}</CustomTypography>
                    <Progress percent={progress} showInfo={false} />
                    <div>
                        <div style={{ margin: "8px 0" }}>
                            {
                                reportStatus?.reportAccounts?.map((item, index) => {
                                    return (
                                        <>
                                            <Flex vertical={false} justify="space-between" style={{ borderTop: '1px solid #F0F0F0', borderBottom: '1px solid #F0F0F0', padding: "8px 0" }}>
                                                <CustomTypography style={{ fontWeight: 400, fontSize: "14px", lineHeight: "22px", color: '#000000E0' }}>{`${item.account.bankName} - ${item.account.accountNumber} - ${item.account.accountTypeName}`}</CustomTypography>
                                                <div style={{
                                                    backgroundColor: getBackground(item.account.status),
                                                    border: "1px solid #91CAFF",
                                                    borderRadius: "4px",
                                                    padding: "4px 8px"
                                                }}>
                                                    <CustomTypography style={{ fontWeight: 400, fontSize: "14px", lineHeight: "22px", color: getColor(item.account.status) }}>{item.account.statusDescription}</CustomTypography>
                                                </div>
                                            </Flex>
                                        </>
                                    )
                                })
                            }
                        </div>
                        <div>
                            <CustomTypography style={{ fontWeight: 300, fontSize: "14px", lineHeight: "16.8px", color: '#000000E0' }}>{`You can close this window now. We’re continuing to process everything in the background.`}</CustomTypography>
                        </div>
                    </div>
                </Flex>
            </div>
        </Modal>
    );
};

export default ReportStatusModal;
